import React from 'react';
import { Card, Space, Typography, Tooltip } from 'antd';
import { InfoCircleOutlined, ArrowUpOutlined, ArrowDownOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export const KPICard = ({ title, tooltip, value, prefix, suffixText, isUp, prefixIcon, iconColor, bgColor, onClick, subMetrics, isComparing, compareLabel }: any) => (
    <Card
        styles={{ body: { padding: '16px', height: '100%', display: 'flex', flexDirection: 'column' } }}
        style={{ height: '100%' }}
        hoverable={!!onClick}
        onClick={onClick}
    >
        <Space direction="vertical" size="small" style={{ width: '100%', flex: 1 }}>
            <Space size={4}>
                <Text type="secondary" style={{ fontSize: 13 }}>{title}</Text>
                {tooltip && (
                    <Tooltip title={tooltip}>
                        <InfoCircleOutlined style={{ color: '#bfbfbf', fontSize: 13, cursor: 'help' }} />
                    </Tooltip>
                )}
            </Space>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Title level={4} style={{ margin: 0 }}>{prefix}{value}</Title>
                <div style={{ backgroundColor: bgColor, padding: '8px', borderRadius: '8px', display: 'flex' }}>
                    {React.cloneElement(prefixIcon, { style: { fontSize: '20px', color: iconColor } })}
                </div>
            </div>
            {isComparing && (
                <Space size={4}>
                    <Text style={{ color: isUp ? '#52c41a' : '#ff4d4f', fontSize: 12 }}>
                        {isUp ? <ArrowUpOutlined /> : <ArrowDownOutlined />} {suffixText}
                    </Text>
                    <Text type="secondary" style={{ fontSize: 12 }}>vs {compareLabel}</Text>
                </Space>
            )}
        </Space>
        {subMetrics && (
            <div style={{ marginTop: 16, paddingTop: 12, borderTop: '1px solid #f0f0f0', display: 'flex', justifyContent: 'space-between' }}>
                {subMetrics.map((sm: any, idx: number) => (
                    <Space direction="vertical" size={0} key={idx}>
                        <Text type="secondary" style={{ fontSize: 11 }}>{sm.label}</Text>
                        <Text strong style={{ fontSize: 12, color: sm.color }}>{sm.value}</Text>
                    </Space>
                ))}
            </div>
        )}
    </Card>
);
